<template>
	<div class="filter-bar filter-bar--events" data-vv-scope="event-form">
		<div class="global-container">
			<div class="row align-items-center filter-row">
				<div class="col-12 col-sm-4 filter-bar--events-states">
					<filter-group v-bind:filter="filters.StateCode" index="0"></filter-group>
				</div>
				<div class="col-12 col-sm filter-bar--events-or">
					<p>OR</p>
				</div>
				<div class="col-12 col-sm-6 filter-bar--events-radius">
					<div class="row">
						<div class=" col-8 col-sm-6 zipcode-wrapper">
							<filter-group v-bind:filter="filters.Zipcode" index="1"></filter-group>
						</div>
						<div class="col-4 radius">
							<filter-group v-bind:filter="filters.Radius" index="2"></filter-group>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapState, mapActions, mapMutations } from 'vuex';
	import FilterGroup from '../ui/filter-group';

	export default {
		props: ['filters','shownationwide'],
		data: function () {
			return {
				query: '',
				pageSize: 5
			}
		},
		computed: mapState({
			pagination: state => state.listing.pagination,
			specification: state => state.listing.specification,
		}),
		components: {
			'filter-group': FilterGroup,
		},
		mounted() {
			this.query = this.specification.SearchTerm;
		},
		methods: {
			...mapActions('listing', { setFilter: 'setFilter' }),
			...mapMutations('listing', { updateSpecification: 'updateSpecification' }),
			...mapMutations('listing', { resetSpecification: 'resetSpecification' }),
			setPageSize() {
				this.updateSpecification({ key: 'PageSize', value: this.pageSize });
			},
			filter() {
				this.setFilter();
			},
			resetFilter() {
				this.resetSpecification();
			}
		},
	}
</script>